import { Injectable, Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { BulkUpdateListView } from "../../../Data/WebTraderData/BulkUpdateListView";
import { WebtraderService } from "../../../../service/webtrader-service/webtrader.service";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { AuthService } from "../../../../service/auth-service/auth-service.service";

@Injectable({
    providedIn: 'root',
})
export class BulkUpdateList extends BaseNode {

    path:string = '';
    labelPath:string='';

    constructor(
        injector: Injector, 
        private authService: AuthService) {
            super(injector, new BulkUpdateListView([]), 'Bulk Update');
            this.getBulkUpdate();
    }

    getHeaders(): string[] {
        return ['Num','File Name', 'Num/Count', 'Date'];
    }

    getKeys(): string[] {
        return ['num','fileName', 'count', 'date'];
    }

    reset(){
        this.path='';
        this.labelPath='';
        this.getBulkUpdate();
    }

    public getBulkUpdate() {
        if (this.isDeniedBulkUpdateRequest()) {
            return;
        }
        this.ioc!.get(WebtraderService).getBulkUpdateMessages(this.path).subscribe((list: any) => {
            this.data = new BulkUpdateListView(list);
            this.ioc!.get(WebtraderService).loading.next(false);
        }, (error: any) => {
            this.ioc!.get(WebtraderService).loading.next(false);
            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
        });
    }

    isDeniedBulkUpdateRequest(): boolean {
        return !this.authService.hasAnyRole("EVH_WEBTRADER_BULKUPDATE");
    }

}